export const ACTIVE_HEALTH_BILLING_DISCOUNT_PROBLEM_STATUS_TITLE = {
  PENDING: 'รอดำเนินการ',
  RESOLVED: 'แก้ไขแล้ว',
}
